export * from 'server/models/CruiseActivity';


// WEBPACK FOOTER //
// ./data/models/CruiseActivity.ts